import './styles.scoped.css'
import {Typography, Button, Modal, Avatar} from '@mui/material'
import {Logout} from '@mui/icons-material'
import axios from 'axios'
import {useAuth} from '../../contexts/AuthContext'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'

export default () => {
    const {setAccount} = useAuth()
    const {logout, setLogout, setLoading} = useGlobalStates()

    const handleLogout = async () => {
        setLoading(true)
        try {
            const response = await axios.post(
                '/auth/logout',
                {},
                {
                    withCredentials: true,
                    headers: {'Content-Type': 'application/json'},
                },
            )
            setLoading(false)
            setAccount(null)
            if (response?.data?.logout_url) {
                window.location.href = response?.data?.logout_url
            } else {
                window.location.href = '/login'
            }
        } catch (error) {
            setLoading(false)
            setAccount(null)
            window.location.href = '/login'
        }
    }

    return (
        <Modal open={logout}>
            <div className="container">
                <div className="content">
                    <div className="icon">
                        <Avatar style={{width: 64, height: 64, backgroundColor: '#D32F2F14'}}>
                            <Logout color="error" fontSize="large" />
                        </Avatar>
                    </div>
                    <br />
                    <Typography variant="h6" color="text.primary" className="title">
                        Logout
                    </Typography>
                    <br />
                    <Typography variant="body1" color="text.primary" className="title">
                        Are you sure you want to logout?
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button onClick={() => setLogout(false)} variant="outlined" fullWidth>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={handleLogout}>
                            Yes, Logout
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
